export default __webpack_public_path__ + "static/media/SB_Rectangle1.91c74e14.svg";